'use strict'

const watermark = {}
/**
 *
 * @param {要设置的水印的内容} str
 * @param {需要设置水印的容器} container
 */

const setWatermark = (str, container) => {
  const id = '1.23452384164.123412415'
  
  if (container === undefined) {
    return
  }

  // 查看页面上有没有，如果有则删除
  if (document.getElementById(id) !== null) {
    const childelement = document.getElementById(id)
    childelement.parentNode.removeChild(childelement)
  }

  let containerWidth = container.offsetWidth // 获取父容器宽
  // let containerHeight = container.offsetHeight // 获取父容器高 （当文档很长时，无法获取最高高度）
  let containerHeight = Math.max(document.documentElement.scrollHeight, document.documentElement.clientHeight) + 20000
  container.style.position = 'relative' // 设置布局为相对布局
  container.style.overflow = 'hidden'

  // 创建canvas元素(先制作一块背景图)
  const can = document.createElement('canvas')
  can.width = containerWidth / 3 // 设置每一块的宽度
  can.height = 330 // 高度
  const cans = can.getContext('2d') // 获取canvas画布
  cans.globalAlpha = 0.4

  // if (str === '草稿') {
  //   cans.rotate(-20 * Math.PI / 180) // 逆时针旋转π/9
  //   cans.font = '36px Vedana' // 设置字体
  //   // cans.fillStyle = 'rgba(189, 195, 199, 0.9)' // 设置字体的颜色
  //   cans.fillStyle = 'rgba(105,105,105, 0.7)' // 设置字体的颜色
  //   cans.textAlign = 'center' // 文本对齐方式
  //   cans.textBaseline = 'Middle' // 文本基线
  //   cans.fillText(str, 440, 4 * can.height / 5) // 绘制文字
  // } else {
  //   cans.drawImage(str, 450, 115, 100, 100)
  // }
    cans.rotate(-20 * Math.PI / 180) // 逆时针旋转π/9
    cans.font = `32px Vedana` // 设置字体
    // cans.fillStyle = 'rgba(189, 195, 199, 0.9)' // 设置字体的颜色
    cans.fillStyle = 'rgba(105,105,105, 0.7)' // 设置字体的颜色
    cans.textAlign = 'center' // 文本对齐方式
    cans.textBaseline = 'Middle' // 文本基线
    cans.fillText(str, 240, 4 * can.height / 5) // 绘制文字
    // cans.drawImage(str, 450, 115, 100, 100)

  // 创建一个div元素
  const div = document.createElement('div')
  div.id = id // 设置id
  div.style.pointerEvents = 'none' // 取消所有事件
  div.style.top = '0'
  div.style.left = '0'
  div.style.position = 'absolute'
  div.style.zIndex = '0'
  div.style.width = containerWidth + 'px'
  div.style.height = containerHeight + 'px'
  div.style.background = 'url(' + can.toDataURL('image/png') + ') -200px 0 repeat'
  container.appendChild(div) // 追加到页面

  return id
}

// 该方法只允许调用一次
watermark.set = (str, container) => {
  let id = setWatermark(str, container)
  setInterval(() => {
    if (document.getElementById(id) === null) {
      id = setWatermark(str, container)
    }
  }, 500)
  // 监听页面大小的变化
  window.onresize = () => {
    setWatermark(str, container)
  }
}

export default watermark
